import { DateTime } from '@ksyos/date-time';
import type { IRequestsFindFilter } from '../../../interfaces/requestsFindFilter';

export function requestFindFilter(searchTerm: string, includeProcessIdFilter: boolean = true) {
    const filterData: IRequestsFindFilter = {};
    const formats = ['D-M-YYYY', 'DD-MM-YYYY', 'D/M/YYYY', 'DD/MM/YYYY', 'DDMMYYYY'];

    if (searchTerm && searchTerm !== '') {
        if (DateTime.parseExact(searchTerm, formats).isValid()) {
            filterData.birthDate = DateTime.parseExact(searchTerm, formats).format('YYYY-MM-DD');
        } else if (includeProcessIdFilter) {
            if (searchTerm.match(/^[a-zA-Z]{1,}[0-9]{1,9}$/)) {
                filterData.processId = searchTerm;
            } else if (searchTerm.match(/^[0-9]{1,9}$/)) {
                filterData.processId = searchTerm;
            } else {
                filterData.text = searchTerm;
            }
        } else {
            filterData.text = searchTerm;
        }
    }

    return filterData;
}
